import { createFileRoute, Outlet } from '@tanstack/react-router';

import { backendApiOrganizationsFindOneOptions } from '@/modules/api/backend/@tanstack/react-query.gen';

export const Route = createFileRoute('/_authenticated/management/organizations/$organizationId')({
  component: Outlet,
  beforeLoad: async ({ params: { organizationId }, context: { queryClient } }) => {
    const organizationData = await queryClient.ensureQueryData(
      backendApiOrganizationsFindOneOptions({
        path: { organizationId },
      }),
    );

    return {
      breadcrumb: organizationData?.name,
    };
  },
});
